import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import React from 'react';
// @ts-expect-error разобраться в импорте и работе с SVG
import SignPic from 'src/assets/sign-pic.svg?react';

import { openNotification } from '../../common/helpers';
import { NotificationTypes } from '../../common/interfaces';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { UploadDocument } from '../../store/api/types.api';
import { userApi } from '../../store/api/user.api';
import { downloadFile } from '../Registration/Documents/Documents.helpers';
import { DocTypeClass } from '../Registration/Registration.interfaces';
import styles from './SignContract.module.scss';

export const SignContract = () => {
  const [uploadFile, { isLoading: loadingUploadFile }] =
    userApi.useUploadFileMutation();

  const { userInfo, documents } = useTypedSelector(
    (state) => state.registration,
  );

  // Получаем id документа для скачивания
  const notSignContractId = userInfo?.docs?.find(
    (doc) => doc.docTypeClass === DocTypeClass.NOT_SIGNED_CONTRACT,
  )?.fileId;

  // Получаем id документа для отправки
  const signContractId = documents.find(
    (doc) => doc.docTypeClass === DocTypeClass.SIGNED_CONTRACT,
  )?.id;

  const [getFileBase64, { isLoading: isLoadingDownload }] =
    userApi.useGetFileBase64Mutation();

  const [signContract, setSignContract] = React.useState<UploadDocument | null>(
    null,
  );

  const handleDownloadFile = async () => {
    if (notSignContractId) {
      try {
        const res = await getFileBase64({
          fileId: notSignContractId,
        }).unwrap();

        if (res.data) {
          downloadFile(res);
        }
      } catch (e) {
        openNotification(
          NotificationTypes.ERROR,
          `Произошла ошибка при скачивании договора`,
        );
      }
    } else {
      openNotification(NotificationTypes.ERROR, `Договор не найден`);
    }
  };

  const sentSignContract = async () => {
    // TODO: добавить .unwrap() во все мутации иначе try catch не будет работать !!!
    if (signContract) {
      try {
        await uploadFile(signContract).unwrap();
        openNotification(
          NotificationTypes.SUCCESS,
          'Договор успешно загружен на сервер',
        );
      } catch (e) {
        openNotification(
          NotificationTypes.ERROR,
          `Произошла ошибка при загрузке договора. Попробуйте ещё раз.`,
        );
        // setFileList([]);
      }
    } else {
      openNotification(NotificationTypes.ERROR, `Необходимо загрузить договор`);
    }
  };

  // Функция подготавливает данные для отправки
  const beforeUpload = async (file: File) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      const base64StringMIME = reader.result as string;
      const base64String = base64StringMIME.split(',')[1];

      if (signContractId) {
        setSignContract({
          fileName: 'Подписанный договор' + '.' + file.name.split('.').pop(),
          number: '-',
          date: '',
          validTo: '',
          comment: '',
          doctypeId: signContractId,
          data: base64String,
        });
      }
    };

    return false; // prevent the file from being uploaded
  };

  return (
    <div>
      <h3 className={styles.title}>Подписание договора</h3>

      <div className={styles['sign']}>
        <div className={styles['sign-pic']}>
          <SignPic />
        </div>
      </div>

      <p className={styles.description}>
        Скачайте ваш договор и отправьте его на проверку в подписанном виде
      </p>

      {notSignContractId && signContractId ? (
        <>
          <div className={styles.buttons}>
            <div>
              <Button
                icon={<DownloadOutlined />}
                style={{ width: 'fitContent' }}
                type="default"
                variant="dashed"
                loading={isLoadingDownload}
                onClick={handleDownloadFile}
              >
                Скачать договор
              </Button>
            </div>

            <div className={styles.upload}>
              <Upload
                // запрещаем отправлять файл автоматически (antd)
                beforeUpload={beforeUpload}
                multiple={false}
                maxCount={1}
                onRemove={() => setSignContract(null)}
              >
                <Button
                  block
                  color="primary"
                  variant="outlined"
                  icon={<UploadOutlined />}
                >
                  Загрузить договор
                </Button>
              </Upload>
            </div>
          </div>

          <Button
            size="large"
            type="primary"
            loading={loadingUploadFile}
            onClick={sentSignContract}
          >
            Отправить договор на проверку
          </Button>
        </>
      ) : (
        <p className={styles['error-message']}>
          В настоящее время договор подготавливается менеджером
        </p>
      )}
    </div>
  );
};
